// extracted by mini-css-extract-plugin
module.exports = {"breakAll":"DescriptionText_breakAll__gyqNd","truncate":"DescriptionText_truncate__f9zs4"};